import { createTheme } from "@mui/material";
import { ptBR } from "@mui/x-data-grid/locales";
import { merge } from "lodash";

const buildDefaultTheme = (theme) => {
  if (window.themeOptions && Object.keys(window.themeOptions).length) {
    return merge({}, theme, window.themeOptions);
  }
  return theme;
};

export const themeOptions = buildDefaultTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem", // Reverts to v4 body2 size
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
          backgroundColor: "#fafafa",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#a6a6a6",
          },
        },
        notchedOutline: {
          borderColor: "#a6a6a6",
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          "&:after": {
            borderBottomColor: "#a6a6a6",
          },
          "&:before": {
            borderBottomColor: "#a6a6a6",
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#a6a6a6",
          },
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#f5f5f9",
          color: "rgba(0, 0, 0, 0.87)",
          boxShadow:
            "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",
          fontSize: 11,
        },
      },
    },
  },
  palette: {
    common: { black: "#FFFFFF", white: "#000A69", text: "#000000" },
    primary: { main: "#000A69", light: "#F1F1F1" },

    secondary: { main: "#DEA511", light: "#2C2C2C", dark: "#e9c93d" },

    success: { main: "#43A047", contrastText: "#fff" },
    error: { main: "#B00020", contrastText: "#fff" },
  },
  typography: {},
});

export default createTheme(themeOptions, ptBR);
